/* lua.js generated code 0.3.0 */

let wSize = cc.Director.getInstance().getWinSize()
let BUTTON_BOX_POSITION = 480

let LOWER_BTNX_OFFSET = 60
let LOWER_BTNX_INTERVAL = 80
let PANEL_WIDTH = 450
let panelHeight
let leftScale = -1
let ActionTimeLines = table(
    [1, "kOpen", "open"],
    [1, "kClose", "close"],
    [1, "kNormal", "normal"],
    [1, "kNews", "news"]
)

let ActivitiesButtonsPanel = xClass("ActivitiesButtonsPanel", cc.Node)

var resList = [
    "cocos/activities_buttons_panel.png",
]

ActivitiesButtonsPanel.asyncCreate = function (success, fail, cancel) {
    function onSuccess() {
        let panel = ActivitiesButtonsPanel.create()
        success(panel)
    }
    preloadWithLoading(resList, onSuccess, fail, cancel)
}
ActivitiesButtonsPanel.prototype.ctor = function () {
    let self = this
    cc.Node.prototype.ctor.call(self)
    let bg = cc.Scale9Sprite.create("cocos/activities_buttons_panel.png")
    self.addChild(bg)
    bg.setAnchorPoint(0, 1)
    self.bg = bg

    self.setScale(0)
}
ActivitiesButtonsPanel.prototype.cleanup = function () {
    unloadResList(resList)
    cc.Node.prototype.cleanup.call(this)
}
ActivitiesButtonsPanel.prototype.refreshPosition = function () {
    let self = this
    let boxWidth = 480
    let itemWidth = 75
    let len = $len(self.btns)
    let interv = (boxWidth - len * itemWidth) / (len + 1)

    let lineCount = Math.floor((len - 1) / 3 + 1)
    panelHeight = 150 * lineCount + 50
    self.bg.setContentSize(PANEL_WIDTH, panelHeight)

    for (let i = 1, v = self.btns[1]; v; i++ , v = self.btns[i]) {
        // 计算icon在bg中的坐标，(0, 0)在bg左下角
        v.setAnchorPoint(0.5, 0.5)
        let line = Math.floor((i - 1) / 3) + 1
        let x = (PANEL_WIDTH - 50) / 3 * Math.floor((i - 1) % 3) + 100 // 每行3个
        let y = 150 * (lineCount - line + 1) - 40
        v.setPosition(x, y)
    }
}
ActivitiesButtonsPanel.prototype.addBtn = function (btn) {
    let self = this
    table.insert(self.btns, btn)

    btn.setVisible(false)
    self.bg.addChild(btn)
    self.refreshPosition()
}
ActivitiesButtonsPanel.prototype.addBtns = function (btns) {
    let self = this
    let count = $len(btns)
    for (let i = count; i >= 1; i += -1) {
        let btn = btns[i]
        table.insert(self.btns, btn)

        btn.setVisible(false)
        self.bg.addChild(btn)
    }
    self.refreshPosition()
}
ActivitiesButtonsPanel.prototype.removeBtn = function (btn) {
    let self = this
    table.removebyvalue(self.btns, btn)
    self.bg.removeChild(btn)
    self.refreshPosition()
}
ActivitiesButtonsPanel.prototype.playButtonIdleAnim = function () {
    let self = this
    let actionList = table()
    let time = 0
    let key = null
    if (self.messageCount > 0) {
        key = ActionTimeLines.kNormal
    } else {
        key = ActionTimeLines.kNormal
    }
    self.playAnimation(key, true)
}
ActivitiesButtonsPanel.prototype.playAnimation = function (key, loop, callback) {
    let self = this
    // body
    if (self.animation && self.animation === key) {
        if (callback) {
            callback()
        }
        return
    }

    self.animation = key
    if (key == ActionTimeLines.kOpen) {
        let actionList = table()
        table.insert(actionList, cc.CallFunc.create(function () {
            self.setVisible(true)
            self.setScale(0.1)
        }))
        table.insert(actionList, cc.EaseSineIn.create(cc.ScaleTo.create(5 / 30, 1.1 * leftScale, 1)))
        table.insert(actionList, cc.EaseSineIn.create(cc.ScaleTo.create(3 / 30, 0.9 * leftScale, 1)))
        table.insert(actionList, cc.EaseSineIn.create(cc.ScaleTo.create(3 / 30, 1 * leftScale, 1)))
        table.insert(actionList, cc.CallFunc.create(function () {
            if (callback) {
                callback()
            }
        }))
        self.runAction(cc.Sequence.create(actionList))
    } else if (key == ActionTimeLines.kClose) {
        let actionList = table()
        table.insert(actionList, cc.DelayTime.create(0.8 / 30))
        table.insert(actionList, cc.ScaleTo.create(2 / 30, 1.1 * leftScale, 1))
        table.insert(actionList, cc.ScaleTo.create(3.5 / 30, 0.1 * leftScale, 1))
        table.insert(actionList, cc.CallFunc.create(function () {
            self.setVisible(false)
            if (callback) {
                callback()
            }
        }))
        self.runAction(cc.Sequence.create(actionList))

    }
}
ActivitiesButtonsPanel.prototype.open = function (btns) {
    let self = this
    if (self.isOpen || self.isRunningAnim) {
        return
    }

    let listenner = cc.EventListenerTouchOneByOne.create()
    listenner.setSwallowTouches(true)
    listenner.registerScriptHandler(function (touch, event) {
        let pos = self.bg.convertToNodeSpace(touch.getLocation())
        let rect = cc.rect(0, 0, PANEL_WIDTH, panelHeight)
        if (!cc.rectContainsPoint(rect, pos)) {
            self.close()
        }
        return true
    }, cc.Handler.EVENT_TOUCH_BEGAN)

    self.listenner = listenner
    cc.eventManager.addListener(self.listenner, self)

    self.btns = table()
    self.addBtns(btns)
    self.isOpen = true
    self.isRunningAnim = true
    open_over = function () {
        self.isRunningAnim = false
    }
    self.playAnimation(ActionTimeLines.kOpen, false, open_over)
    self.touchLayer = cc.Layer.create()
    self.touchLayer.setContentSize(wSize)
    self.addChild(self.touchLayer, 0)

    let $let33 = $len(self.btns)
    for (let i = $let33; i >= 1; i += -1) {
        let actionList = table()
        table.insert(actionList, cc.DelayTime.create(i * 2 / 30))
        table.insert(actionList, cc.CallFunc.create(function () {
            self.btns[i].setVisible(true)
            // self.btns[i].setScale(0.1)
            self.btns[i].setScaleX(0.1 * leftScale)
        }))
        table.insert(actionList, cc.EaseSineIn.create(cc.ScaleTo.create(5 / 30, 1.1 * leftScale, 1)))
        table.insert(actionList, cc.EaseSineIn.create(cc.ScaleTo.create(3 / 30, 0.9 * leftScale, 1)))
        table.insert(actionList, cc.EaseSineIn.create(cc.ScaleTo.create(3 / 30, 1 * leftScale, 1)))
        self.btns[i].runAction(cc.Sequence.create(actionList))
    }
}
ActivitiesButtonsPanel.prototype.close = function () {
    let self = this
    if (!self.isOpen || self.isRunningAnim) {
        return
    }
    self.isOpen = false
    self.isRunningAnim = true
    close_over = function () {
        self.playButtonIdleAnim()
        self.isRunningAnim = false
    }
    closeBox = function () {
        // body
        self.playAnimation(ActionTimeLines.kClose, false, close_over)
    }
    self.runAction(cc.Sequence.create(cc.DelayTime.create(0.1), cc.CallFunc.create(closeBox)))
    if (self.touchLayer) {
        self.touchLayer.runAction(cc.Sequence.create(cc.DelayTime.create(0.1), cc.CallFunc.create(function () {
            self.touchLayer.removeFromParent(true)
            self.touchLayer = null
        })))
    }
    let $limit43 = $len(self.btns)
    for (let i = 1; i <= $limit43; i += 1) {
        let actionList = table()
        table.insert(actionList, cc.DelayTime.create(i * 0.8 / 30))
        table.insert(actionList, cc.ScaleTo.create(2 / 30, 1.1 * leftScale, 1))
        table.insert(actionList, cc.ScaleTo.create(3.5 / 30, 0.1 * leftScale, 1))
        table.insert(actionList, cc.CallFunc.create(function () {
            self.btns[i].setVisible(false)
        }))
        self.btns[i].runAction(cc.Sequence.create(actionList))
    }
    cc.eventManager.removeListener(self.listenner)
}
ActivitiesButtonsPanel.prototype.setMessageCount = function (value) {
    let self = this
    self.messageCount = value
    if (self.messageCount > 0) {
        self.prompt.setVisible(true)
        self.promptLabel.setString(UIUtils.getPromptNumStr(self.messageCount))
    } else {
        self.prompt.setVisible(false)
    }
    if (!self.isOpen && !self.isRunningAnim) {
        self.playButtonIdleAnim()
    }
}
module.exports = ActivitiesButtonsPanel
